import {
  validateFieldSync,
  validateFormSync,
} from 'src/utils/validation/validate-generators';
import required from 'src/utils/validation/required';
import { Resolver } from 'react-hook-form';
import {
  flagB,
  flagC,
} from 'src/pages/registration/partials/FormFlag/FormFlag.config';

export const flagCreditAssignment = 'flag-credit-assignment';

export const formConfigFlagStepRegistration = () => {
  const initialValues = {
    [flagCreditAssignment]: false,
    [flagB]: false,
    [flagC]: false,
  };

  const validate = (values: any) => {
    return validateFormSync({
      [flagCreditAssignment]: validateFieldSync(required),
    })(values);
  };

  const resolver: Resolver<any> = async (values: any) => {
    return {
      values: values,
      errors: validate(values),
    };
  };
  return { initialValues, resolver };
};
